import {useTranslation} from 'react-i18next';
import * as css from './TransactionActions.css';
import Celebrate from '../../../../assets/icons/Celebrate';
import Print from '../../../../assets/icons/Print';
// import CalendarPlus from '../../../../assets/icons/CalendarPlus';
import Person from '../../../../assets/icons/Person';
import Receipt from '../../../../assets/icons/Receipt';
import CancelTicket from '../../../../assets/icons/CancelTicket';
import DotsHorizontal from '../../../../assets/icons/DotsHorizontal';
import {TEticketLinks, TEticketTransaction, TCancelTicket} from '../../../../redux/eTicket/eTicket.type';
// import {TEticketEvent, TEticketLinks, TEticketTransaction} from '../../../../redux/eTicket/eTicket.type';
import {hasCharge, openUrl} from '../transactionCardUtils';
// import {buildCalendarUrl, hasCharge, openUrl} from '../transactionCardUtils';
import {cancelTicket} from '../../TicketMenue/fabMenu';

interface TransactionActionsProps {
    // event: TEticketEvent;
    links?: TEticketLinks;
    transaction?: TEticketTransaction;
    collapsed: boolean;
    onExpand: () => void;
    cancel?: TCancelTicket;
}

function TransactionActions({links, transaction, collapsed, onExpand, cancel}: TransactionActionsProps) {//event
    const {t} = useTranslation('eTicket');
    const items = [
        {key: 'event-page', label: t('actionEventPage'), Icon: Celebrate, onClick: () => openUrl(links?.eventPage)},
        {key: 'print', label: t('actionPrint'), Icon: Print, onClick: () => window.print()},
        // {key: 'calendar', label: t('actionAddToCalendar'), Icon: CalendarPlus, onClick: () => event && openUrl(buildCalendarUrl(event))},
        hasCharge(transaction?.price) && {key: 'receipt', label: t('actionReceipt'), Icon: Receipt, onClick: () => openUrl(links?.receipt)},
        cancel?.allowed && {key: 'cancel-ticket', label: t('actionCancelTicket'), Icon: CancelTicket, onClick: () => cancelTicket(links?.cancel, cancel?.reason, t), danger: true},
        {key: 'personal-area', label: t('actionPersonalArea'), Icon: Person, onClick: () => openUrl(links?.personalArea)}
    ].filter(Boolean) as {key: string; label: string; Icon: typeof Receipt; onClick: () => void; danger?: boolean}[];
    return (
        <css.actions data-cy="transaction-actions">
            <css.full className={collapsed ? 'is-collapsed' : ''}>
                <css.actionsTitle>{t('availableActions')}</css.actionsTitle>
                <css.grid>
                    {items.map(({key, label, Icon, onClick, danger}) => (
                        <css.action key={key} type="button" onClick={onClick} className={danger ? 'is-danger' : ''} data-cy={`transaction-action-${key}`}>
                            <css.iconCircle><Icon /></css.iconCircle>
                            <css.actionLabel>{label}</css.actionLabel>
                        </css.action>
                    ))}
                </css.grid>
            </css.full>
            <css.kebab
                className={collapsed ? 'is-collapsed' : ''}
                type="button"
                onClick={onExpand}
                aria-label={t('availableActions')}
                data-cy="transaction-actions-expand">
                <DotsHorizontal />
            </css.kebab>
        </css.actions>
    );
}

export default TransactionActions;
